module.exports = __webpack_public_path__ + "img/app3.ed57915f.png";